import { defineMessages } from 'react-intl'

export const offerTypeTitleMessages = defineMessages({
  cruises: {
    id: 'Oxjkf_auVs15_dWac_Y0',
    defaultMessage: 'Cruises',
  },
  homesAndVillas: {
    id: '-Atrwzu3_j--mQ2JIDMf',
    defaultMessage: 'Homes & Villas',
  },
  experiences: {
    id: 'W3h42tf8zuZwxfONuafz',
    defaultMessage: 'Experiences',
  },
  flights: {
    id: 'ep6bplwWi4B0hsT7ZLqd',
    defaultMessage: 'Flights',
  },
  carHire: {
    id: 'jM3c5eS3RS8io2BEe93X',
    defaultMessage: 'Car Hire',
  },
})

export const offerTypeDescriptionMessages = defineMessages({
  hotels: {
    id: 'c6u04c71dxl7ZWjXKrIR',
    defaultMessage: 'The best hotels and resorts in the world',
  },
  tours: {
    id: '_2Zb8fHVE24pMXlik_6g',
    defaultMessage: 'Tours that do all the hard work for you',
  },
  cruises: {
    id: 'anZjFspIz7SyoM7a2hrW',
    defaultMessage: 'Thousands of itineraries all around the world',
  },
  ultraLux: {
    id: 'SfSnXMfoSmjlWsjGYLrY',
    defaultMessage: 'Experience the world’s most luxurious hotels, tours & cruises',
  },
  homesAndVillas: {
    id: 'BpAQ5EPZGTaVwvdU74Fa',
    defaultMessage: 'Entire properties for the ultimate escape',
  },
  experiences: {
    id: 'qaujMTU7Ark_SzbLHxEW',
    defaultMessage: 'Immerse yourself in your destination',
  },
  flights: {
    id: 'FCqM3fXZTW3jnB62P2v-',
    defaultMessage: 'Your ticket to the world',
  },
  carHire: {
    id: 'BrrigfncI1D4y4ndLETW',
    defaultMessage: 'Making it easy to get from A to B',
  },
})
